/**
 * Return construct a url for a background image
 * e.g. www.withjoy.com/assets/image.jpg ->
 * url("www.withjoy.com/assets/image.jpg")
 * @param {string} url - The title of the book.
 */
export const backgroundImageForUrl = <T>(url: T) => {
  if (url && typeof url === 'string') {
    return `url("${url}")`;
  }
  return url;
};

export const backgroundImageWithDarkOverlay = <T>(url: T) => {
  if (url && typeof url === 'string') {
    return ['linear-gradient(rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.32))', !!url && typeof url === 'string' && `url("${url}")`, 'linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 1))']
      .filter(Boolean)
      .join(', ');
  }
  return url;
};
